//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { LoggerService } from './../common/common.module'
import { ColumnModel } from '../api/api.models'
import { EventsNames } from '../../helpers/events-names'
import { BaseGridGridsterController, ScopeBaseGridsterGrid } from '../common/common.base.grid.gridster.controller'
import { GridOptions, GridTypes, GridController, ButtonsOptions } from '../common/grid/grid.controller'
import { Enums } from '../../models/common/enums'
import { CommonHelper } from '../../helpers/common-helper'
import { GridDetailsController } from '../common/grid-details/grid-details.directive.controller'
import { UserSessionService } from '../../services/user-session'

import { LocalizationHelper } from '../../helpers/localization-helper'

import { Activity } from '../../models/common'
import { LogHelper, ToastHelper } from '../../helpers'
import { GridContextMenuService } from '../../services/grid'
import { OpConfigurationProfile } from '../../models/core'
import { CreateEditResult, DetailsResult, SystemService } from '../../services/system'
import { GridCustomButtonsOptions } from '../common/grid'
import { ConfigurationProfileService } from '../../services/configuration-profile'
import { IIMRConfirmationPopup, IMRConfirmationPopupInitializedArgs, IMRConfirmationPopupOptions } from '../common/confirmation-popup2'



export interface ConfigurationProfileScope
    extends ScopeBaseGridsterGrid {
    mainGridOptions: GridOptions
}

export class ConfigurationProfileController
    extends BaseGridGridsterController {

    public confirmationPopupOptions: IMRConfirmationPopupOptions
    private confirmationPopup: IIMRConfirmationPopup

    //#region Consts

    private get CONFIGURATION_PROFILE_GRID_NAME(): string { return 'ConfigurationProfilesGrid' }

    //#endregion

    //#region Members

    private grid: GridController<OpConfigurationProfile>

    //#endregion

    //#region Ctor

    constructor(
        protected $scope: ConfigurationProfileScope,
        protected $state: StateService,
        protected $timeout: ng.ITimeoutService,
        protected api: Api,
        private logger: LoggerService,
        protected localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService,
        protected configurationProfileService: ConfigurationProfileService,
        private gridContextMenuService: GridContextMenuService,
        protected systemService: SystemService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(
            $scope,
            $timeout,
            $state,
            userSession,
            systemService,
            api,
            localDictionary,
            null,
            GridDetailsController.getOptionsByReferenceType(referenceType),
            Enums.SimaxModuleName[moduleName],
            referenceType,
            true
        )

        this.setConfirmationsOptions()
        this.setEvents()
        this.setMainGridOptions()
    }

    //#endregion

    //#region Events

    private onInitialized(e: any, grid: GridController<OpConfigurationProfile>): void {
        this.dataGrid = e.component
        this.grid = grid

        this.setGridId(e.tableId)
        this.onGridInit(e.tableId)
    }

    private onAdd(template: number): void {
        this.configurationProfileService
            .openCreate(template)
            .then((result: CreateEditResult<OpConfigurationProfile>) => {
                if (result.status === CreateEditResult.Status.Success) {
                    this.onSaved();
                }
            });
    }

    private onConfirmDelete(): void {
        this.configurationProfileService
            .deleteConfigurationProfile(this.grid.selectedItemId)
            .then(() => {
                this.onDeleted()
            })
            .fail((error: any) => {
                LogHelper.error(ConfigurationProfileService.LOG_PREFIX, error)
            })
    }

    private onEdit(): void {
        if (this.grid.selectedCount === 1) {
            const idConfigurationProfile = this.grid.selectedItemId

            this.configurationProfileService
                .openEdit(idConfigurationProfile)
                .then((result: CreateEditResult<OpConfigurationProfile>) => {
                    if (result.status === CreateEditResult.Status.Success) {
                        this.onSaved();
                    }
                });
        }
    }

    private onDelete(): void {
        this.confirmationPopup.show()
    }

    private onDeleted(): void {
        this.grid.refresh()
    }

    private onSaved(): void {
        this.grid.refresh();
    }

    private onShowDetails(e: any): void {
        this.configurationProfileService
            .openDetails(this.grid.selectedItemId, this.grid.pageItemsIds)
            .then((result: DetailsResult) => {
                if (result.status === DetailsResult.Status.Deleted || result.status === DetailsResult.Status.Edited) {
                    this.grid.refresh();
                }
            });
    }

    //#endregion Events End

    //#region Setup

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,

            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.CONFIGURATION_PROFILE_LIST) ? "['" + Activity[Activity.CONFIGURATION_PROFILE_LIST] + "']" : null,
            deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.CONFIGURATION_PROFILE_DEL) ? "['" + Activity[Activity.CONFIGURATION_PROFILE_DEL] + "']" : null,
            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.CONFIGURATION_PROFILE_EDIT) ? "['" + Activity[Activity.CONFIGURATION_PROFILE_EDIT] + "']" : null,
            addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.CONFIGURATION_PROFILE_ADD) ? "['" + Activity[Activity.CONFIGURATION_PROFILE_ADD] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,

            onShowClick: (e: any) => this.onShowDetails(e),
            onAddClick: (template: number) => this.onAdd(template),
            onEditClick: () => this.onEdit(),
            onDeleteClick: () => this.onDelete(),
        }
    }

    private getGridCustomButtonOptions(): GridCustomButtonsOptions {
        const buttons: GridCustomButtonsOptions = { buttons: [] }


        return buttons
    }


    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted()
        )

        this.$scope.showDetails = (e: any) => this.onShowDetails(e)

        this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => this.dataGrid.refresh())
    }

    private setMainGridOptions(): void {
        this.configurationProfileService
            .getMainGridColumns()
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                this.$scope.mainGridOptions = {
                    addCustomFilters: true,
                    buttonsOptions: this.getGridButtonsOptions(),
                    customButtonOptions: this.getGridCustomButtonOptions(),
                    columnsDictionary: columns,
                    // dataSourceParser: this.meterService.getMainGridDataSourceParser(),
                    defaultColumnsDictionary: defaultColumns,
                    getDataSourceMethod: this.userSession.getDataProvider().ConfigurationProfile.getConfigurationProfileFilter,
                    idReferenceType: this.referenceType,
                    localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.meterSaved,
                    name: this.CONFIGURATION_PROFILE_GRID_NAME,
                    preExecuteClearFilter: this.preExecuteGridClearFilter,
                    referenceId: this.referenceType,
                    type: GridTypes.MAIN,

                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.ConfigurationModuleMainGrid),

                    // contextMenuItems: (isTouchScreen: boolean = false) => this.getContextMenuItems(isTouchScreen),
                    onDataReady: (data: any) => this.onDataReady(data),
                    onInitialized: (e: any, grid: GridController<OpConfigurationProfile>) => this.onInitialized(e, grid),
                    onRowDoubleClick: (e: any) => this.onShowDetails(e),
                    onSelectionChanged: (e: any) => this.onSelectionChanged(e),
                }
            })
    }

    private setConfirmationsOptions(): void {
        this.confirmationPopupOptions = {
            content: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName),
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => {
                this.onConfirmDelete()
            },

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            }
        }
    }
}

